import React, { useState, useEffect } from 'react'

import '../../sytles/button.scss'

const BingoSquareY = () => {
    const [clicked, setClicked ] = useState(window.localStorage.getItem('toggleBtnHandler66') === 'true')

    useEffect(() => {
      window.localStorage.setItem('toggleBtnHandler66', clicked)
    }, [clicked]);

    const toggleBtnHandler = () => {
      setClicked(!clicked)
    }  

     {
      const styles = ['button']
      let text = 'Gauntlet drop!'
      let bodyEl = document.body
      bodyEl.style.background = '#1f1f1f'
      
      if (clicked) {
        styles.push('clicked')
        text = 'Gauntlet drop!';
        bodyEl.style.background = '#EEE'
      } 
      return (
     <div className={`main ${clicked ? "toggleBtnHandler": ''}`}>
        <div className={BingoSquareY}>
            <button className={styles.join(' ')} onClick={toggleBtnHandler}>{text}</button>
        </div>
     </div>
      )
    }
  }

  export default BingoSquareY
  
